module.exports = __webpack_public_path__ + "img/sam-tank-pride-01.819fa862.jpg";